export const MISSION_ASSESSMENT_ACCESS_RESTRICTED_MESSAGE = 'You no longer have access to this organization.';
